import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ConfigurationService, PortalConfigurationService } from '@draeger-academy/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
registerLocaleData(localeDe, 'de');

@Component({
    selector: 'da-checkout-list-event-price',
    templateUrl: './checkout-list-event-price.component.html',
    styleUrls: ['./checkout-list-event-price.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckoutListEventPriceComponent implements OnInit {
    @Input() price: string;
    @Input() currency: string;

    constructor(
        private _configurationService: ConfigurationService,
        private _portalConfigurationService: PortalConfigurationService

    ) {}

    private _$pricePattern: BehaviorSubject<string> = new BehaviorSubject('');
    public get pricePattern$(): Observable<string> {
        return this._$pricePattern.asObservable();
    }

    private _$formattedPrice: BehaviorSubject<string> = new BehaviorSubject('');
    public get formattedPrice$(): Observable<string> {
        return this._$formattedPrice.asObservable();
    }

    ngOnInit() {
        this.formatingPrice();
    }

    private formatingPrice(){      
        if (this._configurationService.isPartnerPage()) {
                this._portalConfigurationService.currencyPattern$.subscribe((currencyPattern) => {
                    this._$formattedPrice.next(this.formatPrice(this.price, currencyPattern));
                });
        } else {
            this._$pricePattern.next('#.##0,00 " $"');
            this._$formattedPrice.next(this.formatPrice(this.price, this._$pricePattern.getValue()));
        }
    }

    private formatPrice(price: any, formatPattern){
        if (formatPattern){
            return this._configurationService.formatPrice(price, formatPattern, this.currency);
        } else {
            return price;
        }
    }
}
